import { firstNonBlank, lineEnd, lineStart, moveDown, moveLeft, moveRight, moveUp } from "./basic";
import { findCharBackward, findCharForward, tillCharBackward, tillCharForward } from "./find-char";
import { goToFirstLine, goToLastLine } from "./line";
import { paragraphBackward, paragraphForward } from "./paragraph";
import type { MotionFn } from "./types";
import { wordBackward, wordEndForward, wordForward } from "./word";

/** 単一キーで確定するモーション名（`gg` は2打のため interpreter で別途扱う）。 */
export type SingleKeyMotionName =
  | "h"
  | "j"
  | "k"
  | "l"
  | "w"
  | "b"
  | "e"
  | "0"
  | "^"
  | "$"
  | "G"
  | "{"
  | "}";

/** `f` `t` は2打目に文字を取るため、単一キーモーションとしては扱わない（interpreterで個別処理）。 */
export type FindCharMotionName = "f" | "t" | "F" | "T";

export type MotionName = SingleKeyMotionName | "gg" | FindCharMotionName;

export const SINGLE_KEY_MOTIONS: ReadonlyMap<SingleKeyMotionName, MotionFn> = new Map([
  ["h", moveLeft],
  ["j", moveDown],
  ["k", moveUp],
  ["l", moveRight],
  ["w", wordForward],
  ["b", wordBackward],
  ["e", wordEndForward],
  ["0", lineStart],
  ["^", firstNonBlank],
  ["$", lineEnd],
  ["G", goToLastLine],
  ["{", paragraphBackward],
  ["}", paragraphForward],
]);

export const MOTIONS: ReadonlyMap<MotionName, MotionFn> = new Map([
  ...SINGLE_KEY_MOTIONS,
  ["gg", goToFirstLine],
  ["f", findCharForward],
  ["t", tillCharForward],
  ["F", findCharBackward],
  ["T", tillCharBackward],
]);

export function isSingleKeyMotion(key: string): key is SingleKeyMotionName {
  return SINGLE_KEY_MOTIONS.has(key as SingleKeyMotionName);
}

export type { MotionFn } from "./types";
